import { CalendarOutlined, ClockCircleOutlined, EnvironmentOutlined, FieldTimeOutlined, GiftOutlined, PhoneOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";

export const cardIcons = {
  date: <CalendarOutlined />,
  startDate: <CalendarOutlined />,
  endDate: <CalendarOutlined />,
  time: <ClockCircleOutlined />,
  startTime: <ClockCircleOutlined />,
  endTime: <ClockCircleOutlined />,
  location: <EnvironmentOutlined />,
  contact: <PhoneOutlined />,
  dob: <GiftOutlined />,
  team: <TeamOutlined />,
  gender: <UserOutlined />,
  phone: <PhoneOutlined />,
  status: <FieldTimeOutlined />,
  patientName:<UserOutlined />
}